import React, { ReactNode } from 'react'
import { useTranslation } from 'language/translator'

import { RollingType } from 'types/GlobalKpiOption'

import { TRANSLATE_ROLLING } from 'utils/enumTranslator'

import Grid from 'components_new/atoms/Grid'
import Switch from 'components_new/atoms/Switch'

import SettingsGroup from 'components_new/molecules/SettingsGroup'
import SettingsItem from 'components_new/molecules/SettingsItem'
import SettingsToggleOption from 'components_new/molecules/SettingsToggleOption'


interface RollingSectionProps {
  // a rolling sum cannot follow a financial year period
  isFinancialYear: boolean
  onChange: (rollingSum: RollingType | null) => void
  options: RollingType[]
  selected: RollingType | null

  // NOT REQUIRED PROPS

  // the setting is decided elsewhere, and the text says where
  disabled?: boolean
  disabledText?: ReactNode
}

const RollingSection = (props: RollingSectionProps) => {
  const {
    disabled, disabledText, isFinancialYear, onChange, options, selected
  } = props
  const { t, translateEnum } = useTranslation()

  if (options.length === 0) return null

  // the rolling sum cannot be changed under a financial year period,
  // or when the caller decides the setting elsewhere
  const state: { disabled: boolean; text: ReactNode } = disabled
    ? { disabled: true, text: disabledText }
    : {
        disabled: isFinancialYear,
        text: t('widgets', 'rolling_disabled_for_financial_year')
      }

  return (
    <>
      <SettingsGroup
        title={t('metrics', 'rolling_sum')}
        helperText={t('metrics', 'rolling_sum_helper_text')}
      >
        <SettingsItem disabled={state.disabled} disabledText={state.text}>
          <Grid container={true} columns={5}>
            {options.map((option) => {
              const isSelected = option === selected

              return (
                <Grid item={true} key={option} xs={1}>
                  <SettingsToggleOption
                    disabled={state.disabled}
                    iconName={TRANSLATE_ROLLING[option].iconName}
                    onClick={() => onChange(isSelected ? null : option)}
                    selected={isSelected}
                    title={translateEnum('rolling_types', option).abbreviation}
                  />
                </Grid>
              )
            })}
          </Grid>
        </SettingsItem>
        {selected !== null ? (
          <SettingsItem
            actions={
              <Switch
                checked
                disabled={state.disabled}
                onChange={() => onChange(null)}
                size="small"
              />
            }
            disabled={state.disabled}
            disabledText={state.text}
            title={t('global', 'activated')}
          />
        ) : null}
      </SettingsGroup>
    </>
  )
}

export default RollingSection
